export const textIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M5.235 20v-1.535c1.852 0 3.176-.987 3.176-3.07V4.737c0-1.611-1.192-2.105-2.812-2.105s-2.746.494-2.746 2.105H1V0h18v4.737h-1.853c0-1.611-1.126-2.105-2.746-2.105s-2.812.494-2.812 2.105v10.658c0 2.083 1.325 3.07 3.176 3.07V20z"/></svg>`,
  name: 'text',
};
